'use client';
const emailRegExp = /^\S+@\S+\.\S+$/g;

export { emailRegExp };
//# sourceMappingURL=email.js.map
